import * as ambassadorWixLoyaltyReferralV1ReferralReward from './loyalty-referral-v1-referral-reward-rewards.http.js';
import * as ambassadorWixLoyaltyReferralV1ReferralRewardTypes from './loyalty-referral-v1-referral-reward-rewards.types.js';
import * as ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes from './loyalty-referral-v1-referral-reward-rewards.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getReferralReward(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.GetReferralRewardRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.GetReferralRewardRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.GetReferralRewardResponse,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.GetReferralRewardResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralReward.getReferralReward(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/referral-rewards/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReferralRewards(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.QueryReferralRewardsRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.QueryReferralRewardsRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.QueryReferralRewardsResponse,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.QueryReferralRewardsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralReward.queryReferralRewards(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/referral-rewards/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetReferralRewards(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.BulkGetReferralRewardsRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.BulkGetReferralRewardsRequest,
  ambassadorWixLoyaltyReferralV1ReferralRewardUniversalTypes.BulkGetReferralRewardsResponse,
  ambassadorWixLoyaltyReferralV1ReferralRewardTypes.BulkGetReferralRewardsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralReward.bulkGetReferralRewards(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/bulk/referral-rewards',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ReferralReward as ReferralRewardOriginal,
  ReferralRewardReceiverOneOf as ReferralRewardReceiverOneOfOriginal,
  ReferralRewardRewardTypeOptionsOneOf as ReferralRewardRewardTypeOptionsOneOfOriginal,
  RewardTypeType as RewardTypeTypeOriginal,
  RewardTypeTypeWithLiterals as RewardTypeTypeWithLiteralsOriginal,
  V1Coupon as V1CouponOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Coupon as CouponOriginal,
  CouponDiscountTypeOptionsOneOf as CouponDiscountTypeOptionsOneOfOriginal,
  CouponScopeOrMinSubtotalOneOf as CouponScopeOrMinSubtotalOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  FixedAmountDiscount as FixedAmountDiscountOriginal,
  PercentageDiscount as PercentageDiscountOriginal,
  CouponScope as CouponScopeOriginal,
  Group as GroupOriginal,
  V1LoyaltyPoints as V1LoyaltyPointsOriginal,
  GetReferralRewardRequest as GetReferralRewardRequestOriginal,
  GetReferralRewardResponse as GetReferralRewardResponseOriginal,
  QueryReferralRewardsRequest as QueryReferralRewardsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryReferralRewardsResponse as QueryReferralRewardsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ValidateReferralRewardRequest as ValidateReferralRewardRequestOriginal,
  Reward as RewardOriginal,
  RewardOptionsOneOf as RewardOptionsOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  LoyaltyPoints as LoyaltyPointsOriginal,
  ValidateReferralRewardResponse as ValidateReferralRewardResponseOriginal,
  BulkGetReferralRewardsRequest as BulkGetReferralRewardsRequestOriginal,
  BulkGetReferralRewardsResponse as BulkGetReferralRewardsResponseOriginal,
  RewardsInSite as RewardsInSiteOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SuccessfulReferralEvent as SuccessfulReferralEventOriginal,
  ReferredFriendDetails as ReferredFriendDetailsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-referral-v1-referral-reward-rewards.types.js';
